import React, { useState, useEffect, useContext, useRef } from 'react';
import { Dialog, Slide } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import usePostDataToServer from '../../hooks/usePostDataToServer';
import FormElement from '../../components/form/FormElement';
import CloseIcon from '@mui/icons-material/Close';
import useGetDataFromServer from '../../hooks/useGetDataFromServer';
import AlertContext from "../../context/alerts";
import Spinner from '../../components/spinner';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { checkIfNotEmpty } from '../../utility';
import { displayProductDetails } from '../../apis/productlistapi';
import { AsyncPaginate } from 'react-select-async-paginate';
import useGetVendorDropdown from '../../hooks/useGetVendorDropdown';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function EditPurchaseProduct({ open, onClose, singleData }) {

    const { sendAlert } = useContext(AlertContext)
    const [productFormData, setProductFormData] = useState(singleData)
    const { handleGetData } = useGetDataFromServer("listProduct")
    const listVendor = useGetDataFromServer("listVendor")

    const [isChanged, setIsChanged] = useState(false)

    const [updateDate, setUpdateDate] = useState(new Date(parseInt(productFormData?.date) * 1000))

    const { setDataToServer, error } = usePostDataToServer("/updatePurchaseProduct", "listPurchaseProduct", {
        onSuccessCb: (data) => {
            sendAlert(data?.message, "SUCCESS")
            onClose()
        },
        onErrorCb: (err) => {
            // console.log('error', err)
            sendAlert(err?.response?.data?.message, "WARNING")
        }
    })
    const handleClearAndCloseForm = (e) => {
        e.preventDefault()
        onClose()
    }
    const handleInputs = (e) => {
        let value = e.target.value
        let data = {
            ...productFormData,
            [e.target.name]: value
        }
        if (e.target.name !== 'total_amount') {
            let newcount = data.perpiece_price * data.quantity
            data.total_amount = newcount
        }
        setProductFormData(data)
        setIsChanged(true)
    }


    // Product Scroll Code
    const [roomDropName, setRoomName] = useState([])
    const [pageNoBuilding, setPageNoBuilding] = useState(0);
    const [previousState, setPreviousState] = useState("");

    const initialLoadForEffect = useRef(true);
    const initialLoadBuilding = useRef(false)

    const formatData = (arr, valueName, labelName) => {
        let newarr = []
        for (let i = 0; i < arr?.length; i++) {
            newarr.push({ value: arr[i]?.[valueName], label: arr[i]?.[labelName], ...arr[i] })
        }
        return newarr;
    }

    const getProductName = async () => {
        const res = await displayProductDetails();
        const res2 = formatData(res.data.data, 'product_id', 'product_name')
        setRoomName(res2);
    }
    useEffect(() => { 
        if (initialLoadForEffect.current) {
            getProductName();
            initialLoadForEffect.current = false;
        }
    }, [])

    const loadBuildingNames = (search, prevOptions) => {
        const formatDataFn = (resp) => {
            return formatData(resp, 'product_id', 'product_name')
        }
        return loadOptions(search, prevOptions,
            initialLoadBuilding,
            roomDropName, setRoomName,
            pageNoBuilding, setPageNoBuilding, formatDataFn)
    }

    const loadOptions = async (search, prevOptions, initialLoad, state, setState, pageNo, setPageNo, formatDataFn) => {
        try {
            if (!initialLoad.current && !search) {
                initialLoad.current = true;
                return {
                    options: state,
                    hasMore: true
                };
            }
            else {
                let newPage;
                if (checkIfNotEmpty(search) && previousState !== search) {
                    newPage = 0;
                    setPageNo(newPage);
                } else {
                    // newPage = pageNo;
                    newPage = pageNo + 1;
                    setPageNo(newPage);
                }

                let res = await displayProductDetails(newPage, search)
                newPage = pageNo + 1;
                setPageNo(newPage);

                const data = state.concat(res?.data?.data)
                // setState(data)
                let temps = res.data.data;

                let hasMore = true;
                if (res?.data?.data?.length == 0) {
                    hasMore = false;
                }
                let arr = formatDataFn(res?.data?.data);
                setPreviousState(search)

                return {
                    options: arr,
                    hasMore: hasMore
                };
            }
        }
        catch (err) {
            // console.log(err)
        }
    }

    useEffect(() => {
        if (checkIfNotEmpty(singleData)) {
            setProductFormData(singleData)
        }
    }, [singleData])




    const handleProductName = (e) => {
        let data = {
            ...productFormData,
            product_id: e.product_id,
            product_name: e.product_name
        }
        setProductFormData(data)
        setIsChanged(true)
    }

    const nameFunction = () => {
        // console.log('object data callled for testing :>> ');
        // console.log('roomDropName :>> ', roomDropName.length);


        let name = roomDropName?.find(el => {
            return parseInt(el.product_id) == parseInt(productFormData?.product_id)
        })

        // console.log('name :>> ', name);
        if (checkIfNotEmpty(name)) {
            return name
        } else {
            return {
                id: productFormData?.product_id,
                value: productFormData?.product_id,
                product_name: productFormData?.product_name,
                label: productFormData?.product_name
            }
        }
    }
    // End here

   // Async scroll for vendor
   const { loadVendorNames, getVendorNameFn} = useGetVendorDropdown({productFormData: productFormData});

   const handleVendorChange = (e) => {
       let data = {
           ...productFormData,
           vendor_id: e.id,
           vendor_name: e.name,
       }

       setProductFormData(data);
   }

    const handleSubmitForm = (e) => {
        e.preventDefault()
        let date = new Date(updateDate).toDateString()
        let data = {
            purchase_id: productFormData?.purchase_id,
            perpiece_price: productFormData?.perpiece_price,
            total_amount: productFormData?.total_amount + "",
            product_name: productFormData?.product_name,
            product_id: productFormData?.product_id,
            vendor_id: productFormData?.vendor_id,
            vendor_name: productFormData?.vendor_name,
            quantity: productFormData?.quantity,
            date: date
        }
        setDataToServer.mutate(data)
    }

    const numberInputOnWheelPreventChange = (e) => {
        // Prevent the input value change
        e.target.blur()

        // Prevent the page/container scrolling
        e.stopPropagation()

        // Refocus immediately, on the next tick (after the current function is done)
        setTimeout(() => {
            e.target.focus()
        }, 0)
    }

    return (<Dialog fullScreen fullWidth={true} open={open} onClose={(e) => handleClearAndCloseForm(e)} TransitionComponent={Transition}>
        <div className='container_xxl'>
            <div className='flex items-center space-x-4 sticky headingBorder__b top-0 z-40 bg-white'>
                <div>
                    <IconButton onClick={onClose}>
                        <ArrowBackIcon />
                    </IconButton>
                </div>
                <div>
                    <h1 className='heading capitalize text-2xl'>Edit Purchase Product</h1>
                </div>
            </div>
            <form className='py-7' onSubmit={(e) => handleSubmitForm(e)}>
                <div className='grid grid-cols-3 gap-x-9 gap-y-6'>
                    <div className=''>
                        <label className="block text-xl lato mb-px">Product</label>
                        {/* <select required onChange={handleInputs} name="product_id"
                            value={productFormData?.product_id} className="border-2 border-grey w-full h-12 rounded-md">
                            <option value="" disabled>--Select Type--</option>
                            {handleGetData?.data?.data?.map((categoryDrop, id) => { return <option value={categoryDrop?.product_id}>{categoryDrop?.product_name}</option> })}
                        </select> */}
                        <AsyncPaginate
                            value={nameFunction()}
                            // options={buildingName}
                            isSearchable={true}
                            lab
                            loadOptions={loadBuildingNames}
                            onChange={(e) => handleProductName(e)}
                        />
                    </div>
                    <div className=''>
                        <label className="block text-xl lato mb-px">Vendor</label>
                        <AsyncPaginate
                            value={getVendorNameFn()}
                            isSearchable={true}
                            lab
                            loadOptions={loadVendorNames}
                            onChange={(e) => handleVendorChange(e)}
                        />
                    </div>
                    <div>
                        <label className='label'>Date</label>
                        <DatePicker required
                            // className="px-3 py-1 w-60 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded"
                            className='input mt-1'
                            selected={updateDate} onChange={(date) => setUpdateDate(date)}
                            dateFormat="dd/MM/yyyy"
                        />
                    </div>
                    <div className="mt-1">
                        <FormElement
                            label={"Quantity"}
                            onChange={handleInputs}
                            placeholder={'Quantity'}
                            element={'input'}
                            autocomplete={"off"}
                            value={productFormData?.quantity}
                            name={'quantity'}
                            type={'number'}
                            onWheel={numberInputOnWheelPreventChange}
                            required={'required'}
                            errorMessage={'This is a Required Field'} />
                    </div>
                    <div className="mt-1">
                        <FormElement
                            label={"Per-piece Price"}
                            onChange={handleInputs}
                            placeholder={'Per-piece Price'}
                            element={'input'}
                            value={productFormData?.perpiece_price}
                            name={'perpiece_price'}
                            autocomplete={"off"}
                            type={'number'}
                            onWheel={numberInputOnWheelPreventChange}
                            required={'required'}
                            errorMessage={'This is a Required Field'} />
                    </div>
                    <div className="mt-1">
                        <FormElement
                            label={"Total Amount"}
                            onChange={handleInputs}
                            autocomplete={"off"}
                            placeholder={'Total Amount'}
                            element={'input'}
                            value={productFormData?.total_amount}
                            name={'total_amount'}
                            required={'required'}
                            errorMessage={'This is a Required Field'} />
                    </div>
                </div>
                {setDataToServer.isLoading ?
                    <Spinner /> : isChanged == true ?
                        <div className="flex justify-center mt-10">
                            <button type='submit' className='btn3 text-white'>Edit</button>
                        </div> : <div className="flex justify-center mt-10">
                            <button disabled type='submit' className='btn3 text-white bg-blue-300'>Edit</button>
                        </div>}
            </form>
        </div>
    </Dialog>);
}

export default EditPurchaseProduct;